import * as queryString from "query-string";
import { ModalTypes } from "actions/types";

export function openFreeRoundDetails(route, navigateTo) {
  let params = {
    route: btoa(JSON.stringify(route.toJSON())),
  };

  let newLoc = `${window.location.pathname}?${queryString.stringify(params)}`;

  navigateTo(newLoc);

  return {
    type: ModalTypes.OPEN_FREE_ROUND_DETAILS,
    payload: {
      route,
    },
  };
}
